import { Outlet } from 'react-router-dom';

import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';

const Layout = () => {
  return (
    <RequireAuth>
      <Outlet />
      <ImportLineup />
    </RequireAuth>
  );
};

export default Layout;
